import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import ChargeTransactionList from './charge_transaction_list';
import ChargeTransactionView from './charge_transaction_view';

export default function ChargeTransactionIndex() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = ChargeTransactionList;
      break;

    case 'view':
      ActualPage = ChargeTransactionView;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

